import { render } from "./zhengcCreate.vue?vue&type=template&id=51eadbae"
import script from "./zhengcCreate.vue?vue&type=script&lang=js"
export * from "./zhengcCreate.vue?vue&type=script&lang=js"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__